































































































































































































































































































import Vue from 'vue';
import Block from './block.vue';
import Item from './item.vue';

function isAdmin () {
	return !!localStorage.admin || document.location.hash.startsWith ('#a');
}

export default Vue.extend ({
	name: 'app',
	data () {
		return {
			isAdmin: isAdmin ()
		};
	},
	components: {
		Block,
		Item
	},
	methods: {
		headlinify (name : string) {
			var ret = '';
			for (var i = 0; i < name.length; i++) {
				var c = name.charAt (i), isCaps = (c === c.toUpperCase ());
				if (c === ' ') isCaps = false;
				ret += isCaps ? '<span style="font-size:120%">' + c + '</span>' : c;
			}
			return ret;
		},
		mailAddr () {
			return ['jt','ss',String.fromCharCode(64)+'gm'+'x.d',''].join('e');
		}
	},
	created () {
		window.addEventListener ('hashchange', ev => this.isAdmin = isAdmin (), false);
	}
});



